let loading: Promise<void> | undefined;

export const loadDuoEditor = (): Promise<void> => {
  loading ??= (async () => {
    await import("@duo/fonts");
    await import("@duo/tokens/css");
    await import("@duo/editor/css");
    await import("@duo/editor");
  })().catch((error: unknown) => {
    loading = undefined;
    throw error;
  });
  return loading;
};
